module.exports = __webpack_public_path__ + "img/partner_8.858a868.png";